<template>
    <ideo-form-group :label="$t('[[[Treść]]]')" :invalid-feedback="form.$errors.first('content.value.text')" :state="form.$errors.state('content.value.text')" required>
        <editor :id="seconds('text-' + form.id)" v-model="form.content.value.text" data-cy="content"></editor>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { FormType } from '@/helpers/Form';
import merge from 'lodash/merge';
import { seconds } from '@/helpers/Utils';

interface FormContentMaterial
{
    content: {
        value: {
            text: string
        }
    }
}

@Options({
    name: 'type-content-settings'
})
export default class ContentMaterialSettings extends Vue
{
    @Prop() public modelValue!: any;

    // rozwiązanie problemu inicjalizowania edytora, z powodu dwóch tych samych id-ków
    public seconds = seconds;

    public defaults: any = {
        text: ''
    };

    public get form(): FormType<FormContentMaterial>
    {
        return this.modelValue;
    }

    public created(): void
    {
        this.form.content.value = merge(this.defaults, this.form.content.value);
        this.form.file = null;
    }

    @Watch('form.content.value', { deep: true })
    public onContentChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        this.form.$errors.clear('content.value.text');

        return this.form;
    }
}
</script>
